export default __webpack_public_path__ + "static/logo-800-fc735229ec05ab27c37552f8ed2fed38.gif";